// import { useTranslation } from 'react-i18next';
// import useStyles from './style';
import { Box, Button } from '@mui/material';
import { t } from 'i18next';
import { useNavigate } from 'react-router';
import TPLogo from '../../../assets/images/T-Pest Logo.png';
import SettingImage from '../../../assets/images/setting-image.png';
import Panner from '../../../assets/images/bottomPanerWeb.png';

function MaintenanceScreen() {
  const navigate = useNavigate();
  return (
    <Box width="100%" display="flex" flexDirection="column" height="100%" justifyContent="space-between">
      <Box display="flex" flex="1">
        <Box width="60%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <Box>
            <Box>
              <img src={TPLogo} alt="TPLogo" />
            </Box>
            <Box fontWeight={700} fontSize="48px" marginTop="50px" marginBottom="30px">
              <Box>
                THÔNG BÁO BẢO TRÌ
                <br />
                VÀ NÂNG CẤP HỆ THỐNG
              </Box>
            </Box>
            <Box>
              <Button
                sx={{
                  borderRadius: '20px',
                  fontSize: '14px',
                }}
                variant="outlined"
                onClick={() => navigate('/admin/quan-ly-du-lieu/du-lieu-sau-benh')}
              >
                {t('backHome')}
              </Button>
            </Box>
          </Box>
        </Box>
        <Box width="40%" margin="auto">
          <img src={SettingImage} alt="SettingImage" />
        </Box>
      </Box>
      <Box>
        <img width="100%" src={Panner} alt="Panner" />
      </Box>
    </Box>
  );
}

export default MaintenanceScreen;
